import { render, staticRenderFns } from "./oldVersionMarker.vue?vue&type=template&id=1b4dd44e&scoped=true&"
import script from "./oldVersionMarker.vue?vue&type=script&lang=js&"
export * from "./oldVersionMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4dd44e",
  null
  
)

export default component.exports